

const API_LAMBDA_URL = "https://jj4ffavpixoco6ab3uqwmmxtwy0yzcaf.lambda-url.eu-west-2.on.aws";
const API_BASE_URL = process.env.NODE_ENV === 'production' ? "/api/asktrip" : API_LAMBDA_URL;

const AskTripSessionIdKey = "atsid";
const sessionId = (() => {
    const existingId = localStorage.getItem(AskTripSessionIdKey) || null;
    if (existingId) {
        return existingId;
    }
    const newId=Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem(AskTripSessionIdKey, newId);
    return newId;
})();

export function createQuestion(payload) {

    return new Promise((resolve, reject) => {
        fetch(API_BASE_URL, {
            method: "POST",
            body: JSON.stringify({
                step: "create",
                sessionId,
                ...payload
            })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    reject(data.error);
                } else {
                    resolve(data.result);
                }
            })
            .catch(error => {
                console.error("Error submitting question:", error);
                reject("An error occurred while submitting your question. Please try again later.");
            });
    });
}

export function answerQuestion(questionId) {

    return new Promise((resolve, reject) => {

        fetch(API_LAMBDA_URL, { // always use the lambda URL for answering questions so it doesn't time out
            method: "POST",
            body: JSON.stringify({
                step: "answer",
                sessionId,
                questionId,
            })
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            if (data.error) {
                reject(data.error);
            } else {
                resolve(data.result);
            }
        })
        .catch(error => {
            console.error("Error answering question:", error);
            reject("An error occurred while submitting your question. Please try again later.");
        });
    });
}

export function patchQuestion( params ) {

    return new Promise((resolve, reject) => {
        fetch(API_BASE_URL, {
            method: "POST",
            body: JSON.stringify({
                step: "patch",
                sessionId,
                ...params
            }),
            headers: {
                'x-forwarded-host': window.location.host
            }

        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    reject(data.error);
                } else {
                    resolve(data);
                }
            })
            .catch(error => {
                console.error("Error patching question:", error);
                reject(error);
            });
    });

}

export function canPatchQuestion( params ) {

    return new Promise((resolve, reject) => {
        fetch(API_BASE_URL, {
            method: "POST",
            body: JSON.stringify({
                step: "profile",
                sessionId,
                ...params
            }),
            headers: {
                'x-forwarded-host': window.location.host
            }

        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    reject(data.error);
                } else {
                    resolve(data.user.users_roles.find(ur => ur.role === "AskTripAdmin") !== undefined);
                }
            })
            .catch(error => {
                console.error("Error fetching user:", error);
                reject(error);
            });
    });

}


export function fetchQuestion( params ) {

    return new Promise((resolve, reject) => {
        fetch(API_BASE_URL, {
            method: "POST",
            body: JSON.stringify({
                step: "fetch",
                sessionId,
                ...params
            })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    reject(data.error);
                } else {

                    const result = data.result;
                    const question = {
                        questionId: result.questionId,
                        state: result.state,
                        question: result.question,
                        original: result.original,
                        areas: result.areas || [],
                        types: result.types || [],
                        quality: result.quality || null,
                        timestamp: result.timestamp ? new Date(result.timestamp).toISOString() : null,
                        summary: result.summary || null,
                    };

                    resolve(question);
                }
            })
            .catch(error => {
                console.error("Error fetching question:", error);
                reject(error);
            });
    });

}

export function fetchRelatedQuestions(questionId, sameType = false) {
    return new Promise((resolve, reject) => {
        fetch(API_BASE_URL, {
            method: "POST",
            body: JSON.stringify({
                step: "similar",
                sessionId,
                questionId,
                sameType
            })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    reject(data.error);
                } else {
                    resolve(data.result);
                }
            })
            .catch(error => {
                console.error("Error fetching questions", error);
                reject(error);
            });
    });
}

export function fetchRecentQuestions(filter) {

    return new Promise((resolve, reject) => {
        fetch(API_BASE_URL, {
            method: "POST",
            body: JSON.stringify({
                step: "recent",
                sessionId,
                ...filter
            })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    reject(data.error);
                } else {
                    resolve(data.result.map(result => ({
                        questionId: result.questionId,
                        similarity: result.similarity,
                        state: result.state,
                        slug: result.slug,
                        question: result.question,
                        original: result.original,
                        areas: result.areas || [],
                        types: result.types || [],
                        quality: result.quality || null,
                        timestamp: result.timestamp ? new Date(result.timestamp).toISOString() : null,
                    }))
                    );
                }
            })
            .catch(error => {
                console.error("Error fetching questions", error);
                reject(error);
            });
    });
}

export function countQuestions(filter) {

    return new Promise((resolve, reject) => {
        fetch(API_BASE_URL, {
            method: "POST",
            body: JSON.stringify({
                step: "count",
                sessionId,
                ...filter
            })
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    reject(data.error);
                } else {
                    resolve(data.result);
                }
            })
            .catch(error => {
                console.error("Error counting questions", error);
                reject(error);
            });
    });
}




export async function fetchQuestionTypes() {
    return [
        {
            "id": "causes-risk-factors",
            "title": "Causes & Risk Factors",
            "description": "Why does it happen? Who is at risk?"
        },
        {
            "id": "detection-diagnosis",
            "title": "Detection & Diagnosis",
            "description": "How is it found? What tests are used?"
        },
        {
            "id": "initial-management",
            "title": "Initial Management",
            "description": "First treatments, immediate actions needed"
        },
        {
            "id": "long-term-management",
            "title": "Long-term Management",
            "description": "Ongoing care and monitoring, lifestyle changes and medications"
        },
        {
            "id": "outlook-future-care",
            "title": "Outlook & Future Care",
            "description": "Prognosis, new treatments and research"
        },
        {
            "id": "complications-special-considerations",
            "title": "Complications & Special Considerations",
            "description": "Common problems that arise, special groups like pregnancy/elderly"
        }
    ]

}

export async function fetchClinicalAreas() {
    return [
        { id: "allergy-immunology", title: "Allergy & Immunology" },
        { id: "anaesthetics-pain-management", title: "Anaesthetics & Pain Management" },
        { id: "cardiology", title: "Cardiology" },
        { id: "complementary-alternative-medicine", title: "Complementary & Alternative Medicine" },
        { id: "dentistry", title: "Dentistry" },
        { id: "dermatology", title: "Dermatology" },
        { id: "emergency-medicine", title: "Emergency Medicine" },
        { id: "endocrinology", title: "Endocrinology" },
        { id: "ent", title: "ENT" },
        { id: "ethics-health-humanities", title: "Ethics & Health Humanities" },
        { id: "gastroenterology", title: "Gastroenterology" },
        { id: "genetics", title: "Genetics" },
        { id: "geriatrics", title: "Geriatrics" },
        { id: "haematology", title: "Haematology" },
        { id: "health-policy-services-research", title: "Health Policy & Services Research" },
        { id: "infectious-diseases", title: "Infectious Diseases" },
        { id: "intensive-critical-care", title: "Intensive & Critical Care" },
        { id: "mental-health-psychiatry", title: "Mental Health & Psychiatry" },
        { id: "nephrology", title: "Nephrology" },
        { id: "neurology", title: "Neurology" },
        { id: "obstetrics-gynaecology-womens-health", title: "Obstetrics, Gynaecology & Women's Health" },
        { id: "occupational-environmental-health", title: "Occupational & Environmental Health" },
        { id: "oncology", title: "Oncology" },
        { id: "ophthalmology", title: "Ophthalmology" },
        { id: "orthopaedics", title: "Orthopaedics" },
        { id: "paediatrics", title: "Paediatrics" },
        { id: "palliative-end-of-life-care", title: "Palliative and End-of-Life Care" },
        { id: "pathology-laboratory-medicine", title: "Pathology & Laboratory Medicine" },
        { id: "pharmacology", title: "Pharmacology" },
        { id: "primary-care-generalist-medicine", title: "Primary Care / Generalist Medicine" },
        { id: "public-health-preventive-medicine", title: "Public Health / Preventive Medicine" },
        { id: "radiology-medical-imaging", title: "Radiology & Medical Imaging" },
        { id: "rehabilitation-physical-therapy", title: "Rehabilitation & Physical Therapy" },
        { id: "respiratory-medicine", title: "Respiratory Medicine" },
        { id: "rheumatology", title: "Rheumatology" },
        { id: "sexual-reproductive-health", title: "Sexual & Reproductive Health" },
        { id: "surgery", title: "Surgery" },
        { id: "urology", title: "Urology" }
        ];

}
export function formatDate(dateString) {
    if (!dateString) {
        return 'n/a';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return 'Invalid date';
    }
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
}
